'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Printer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Printer(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? 'Print' : _ref$title,
      _ref$hidden = _ref.hidden,
      hidden = _ref$hidden === undefined ? true : _ref$hidden;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-printer ' + className, width: width, height: height, viewBox: '0 0 16 16', 'aria-label': hidden ? null : title },
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement('path', { fill: color, d: 'M9.5 11h-3c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z' }),
    _react2.default.createElement('path', { fill: color, d: 'M10.5 13h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z' }),
    _react2.default.createElement('path', { fill: color, d: 'M15.916 7.223l-2-3c-0.093-0.139-0.249-0.223-0.416-0.223h-1.5v-3.5c0-0.276-0.224-0.5-0.5-0.5h-7c-0.276 0-0.5 0.224-0.5 0.5v3.5h-1.5c-0.167 0-0.323 0.084-0.416 0.223l-2 3c-0.055 0.082-0.084 0.179-0.084 0.277v5c0 0.276 0.224 0.5 0.5 0.5h2.306l-0.781 2.342c-0.051 0.152-0.025 0.32 0.069 0.45s0.245 0.208 0.406 0.208h11c0.161 0 0.312-0.077 0.406-0.208s0.12-0.298 0.069-0.45l-0.781-2.342h2.306c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.099-0.029-0.195-0.084-0.277zM5 1h6v4h-6v-4zM3.194 15l1.667-5h6.279l1.667 5h-9.613z' })
  );
}

Printer.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Printer/Printer.js
// module id = 289
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15